import { DecimalDTO } from 'models/misc'

/** DecimalDTO with a value of zero */
export const ZERO_DECIMAL: DecimalDTO = {
  value: '0',
  precision: 1,
  scale: 0,
}